import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';
import styled from 'styled-components';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["className", "size", "type"];
var fillSize = {
  16: 8,
  20: 12,
  24: 16
};
var StyledInput = styled.input.withConfig({
  displayName: "Radio__StyledInput",
  componentId: "sc-19dn508-0"
})(["&&{cursor:inherit;opacity:0;height:100%;width:100%;margin:0;padding:0;}"]);
var StyledFill = styled.span.withConfig({
  displayName: "Radio__StyledFill",
  componentId: "sc-19dn508-1"
})(["&&{", ";}"], function (props) {
  return "\n    cursor: inherit;\n    border-radius: 50%;\n    height: ".concat(fillSize[props.size], "px;\n    width: ").concat(fillSize[props.size], "px;\n    position: absolute;\n    top: 2px;\n    left: 2px;\n    background-color: ").concat(props.theme.CTAColors.primary, ";\n    display: none;");
});
var StyledRadio = styled.span.withConfig({
  displayName: "Radio__StyledRadio",
  componentId: "sc-19dn508-2"
})(["&&{", ";", ";", ";", ";", ";}@media (prefers-reduced-motion:reduce){&&:before{transition:none;transform:scale(1);}}"], function (props) {
  return "\n        background-color: ".concat(props.theme.neutralColors.white, ";\n        border: solid 2px ").concat(props.theme.neutralColors.rhino, ";\n        border-radius: 50%;\n        cursor: pointer;\n        display: inline-block;\n        font-size: 0;\n        height: ").concat(props.size, "px;\n        line-height: 0;\n        width: ").concat(props.size, "px;\n        min-width: ").concat(props.size, "px;\n        position: relative;\n        vertical-align: middle;\n        &:before {\n            content: '';\n            display: inline-block;\n            position: absolute;\n            top: -5px;\n            left: -5px;\n            bottom: -5px;\n            right: -5px;\n            border: 1px solid ").concat(props.theme.CTAColors.primaryVariant, ";\n            border-radius: 50%;\n            opacity: 0;\n            transform: scale(0.7);\n        }");
}, function (props) {
  return props.focused && "\n        opacity: 1 !important;\n        outline: 0;\n        &:before {\n            transform: scale(1) !important;\n            opacity: 1 !important;\n            transition: opacity .2s, transform, .2s;\n            \n        }\n    ";
}, function (props) {
  return props.checked && "\n        border: 2px solid ".concat(props.theme.CTAColors.primary, ";\n        ").concat(StyledFill, " { display: block; }\n    ");
}, function (props) {
  return props._disabled && "\n        border-color: ".concat(props.theme.neutralColors.silver, ";\n        background-color: ").concat(props.theme.neutralColors.pearl, ";\n        cursor: not-allowed;\n        ").concat(StyledFill, " { background-color: ").concat(props.theme.neutralColors.silver, "; }\n    ");
}, function (props) {
  return props._disabled && props.checked && "\n        opacity: .5;\n        border-color: ".concat(props.theme.CTAColors.primary, ";\n        background-color: ").concat(props.theme.neutralColors.white, ";\n        cursor: not-allowed;\n        ").concat(StyledFill, " { background-color: ").concat(props.theme.CTAColors.primary, "; }\n    ");
});
var Radio = /*#__PURE__*/React.forwardRef(function Component(props, ref) {
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    focused = _React$useState2[0],
    setFocused = _React$useState2[1];
  var className = props.className,
    _props$size = props.size,
    size = _props$size === void 0 ? 16 : _props$size;
    props.type;
    var inputProps = _objectWithoutProperties(props, _excluded);
  var styleModifiers = {
    checked: props.checked || props.defaultChecked,
    _disabled: props.disabled,
    focused: focused,
    size: size
  };
  var handleOnFocus = function handleOnFocus(e) {
    if (props.onFocus) props.onFocus(e);
    setFocused(true);
  };
  var handleOnBlur = function handleOnBlur(e) {
    if (props.onBlur) props.onBlur(e);
    setFocused(false);
  };
  return /*#__PURE__*/jsxs(StyledRadio, _objectSpread(_objectSpread({}, styleModifiers), {}, {
    className: className,
    children: [/*#__PURE__*/jsx(StyledFill, {
      size: size
    }), /*#__PURE__*/jsx(StyledInput, _objectSpread(_objectSpread({}, inputProps), {}, {
      ref: ref,
      type: "radio",
      onBlur: handleOnBlur,
      onFocus: handleOnFocus
    }))]
  }));
});
Radio.displayName = "Radio";

export { Radio };
